import React from 'react';
import ComputeDetailsTableBase from './ComputeDetailsTableBase';

const ComputeCostTable: React.FC = () => {
  return (
    <ComputeDetailsTableBase
      defaultTitle="Compute Cost Details"
      showComputeCount={false}
    />
  );
};

export default ComputeCostTable;